import { render, staticRenderFns } from "./IncomingTenderAlertBlock.vue?vue&type=template&id=0a8c44a1&"
import script from "./IncomingTenderAlertBlock.vue?vue&type=script&lang=js&"
export * from "./IncomingTenderAlertBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports